angular.module('app.controllers').controller('MainHeaderCtrl', function ($timeout, $window, $translate, $state, UserService, api, notify, areasService, areasListForUser) {
    const vm = this;

    vm.userData = {
        user: UserService.getUser(),
        alerts: [],
    };

    vm.areas = areasListForUser;
    vm.changeArea = (newAreaId) => {
        notify.global(1);
        notify.overlay(1);
        areasService.changeArea(newAreaId, true).then(() => {
            $window.location.reload();
        });
    };

    vm.logout = () => {
        UserService.logout(() => {
            $state.go('login');
        });
    };

    vm.clearCache = () => {
        UserService.getUser(true);

        const EmptyModel = api();
        EmptyModel.clearCache();
        notify.global(1);
        notify.overlay(1);
        $timeout(() => {
            $window.location.reload();
        }, 500);
    };

    $('#menu_top')
        .children('[data-uk-dropdown]')
        .on('show.uk.dropdown', () => {
            $timeout(() => {
                $($window).resize();
            }, 280);
        });

    // wyszukiwarka
    $timeout(() => {
        const searchInput = $('.header_main_search_input');

        searchInput.typeahead(
            {
                highlight: false,
                hint: true,
                minLength: 2,
                classNames: {},
            },
            {
                name: 'global-search',
                display(record) {
                    return record.value.replace(/<[^>]+>/g, '').replace(/^\s+|\s+$/g, '');
                },
                source(q, sync, async) {
                    const type = 'sphinx'; // db

                    return $.ajax(`/api/1/search/${type}/${q}`, {
                        contentType: 'application/json',
                    }).done((data) => {
                        async(data);
                    });
                },
                limit: 100,
                templates: {
                    empty: ['<div class="tt-empty">', $translate.instant('filter.global_no_results'), '</div>'].join('\n'),

                    suggestion(values) {
                        let template = '';
                        let compiled = null;

                        switch (values.type) {
                            case 'client':
                            case 'task':
                            case 'interest':
                            case 'project':
                            case 'phase':
                            case 'user':
                                values.typeTranslated = $translate.instant(`${values.type}s`);
                                template = '<div><u><%= typeTranslated %></u>: <%= value %></div>';
                                break;
                            default:
                                template = '<div></div>';
                                break;
                        }

                        compiled = _.template(template);
                        return compiled(values);
                    },
                },
            }
        );

        searchInput.bind('typeahead:active', (event, data) => {
            notify.overlay(1);
        });

        searchInput.bind('typeahead:open', (event, data) => {
            notify.overlay(1);
        });

        searchInput.bind('typeahead:close', (event, data) => {
            notify.overlay(0);
        });

        searchInput.bind('typeahead:asyncrequest', (event, data) => {
            notify.global(1);
            notify.overlay(1);
        });

        searchInput.bind('typeahead:asynccancel', (event, data) => {
            notify.global(0);
        });

        searchInput.bind('typeahead:render', (event, data, a, b) => {
            notify.global(0);
            notify.overlay(1);
        });

        searchInput.bind('typeahead:select', (event, data) => {
            const stateName = `restricted.${data.type}s_edit`;
            $state.go(stateName, { id: data.id });
        });
    });
});
